module.exports = __webpack_public_path__ + "static/media/blue.8726ed12.png";